import { useEffect, useState } from "react";
import { ChevronDown, Plus, Trash2 } from "lucide-react";
import { apiGet } from "@/lib/apiAdmin";
import { HUD } from "./theme";

const inputCls = `w-full h-10 rounded-xl px-3 text-sm border ${HUD.input}`;

const Member = ({ m, i, perms, upd, remove }) => {
  const [open, setOpen] = useState(false);
  const p = m.permissions || {};
  const setPerm = (k, v) => upd(i, "permissions", { ...p, [k]: v });
  const allOn = Object.keys(perms).every((k) => p[k] !== false);
  return (
    <div className="rounded-xl border border-cyan-400/10 p-3 space-y-3" data-testid={`jarvis-team-row-${i}`}>
      <div className="grid grid-cols-2 sm:grid-cols-[1.2fr_1.2fr_1fr_70px_40px_40px] gap-2">
        <input placeholder="Name" value={m.name} onChange={(e) => upd(i, "name", e.target.value)} data-testid={`jarvis-team-name-${i}`} className={inputCls} />
        <input placeholder="+1 480…" value={m.phone} onChange={(e) => upd(i, "phone", e.target.value)} data-testid={`jarvis-team-phone-${i}`} className={inputCls} />
        <input placeholder="Role" value={m.role} onChange={(e) => upd(i, "role", e.target.value)} data-testid={`jarvis-team-role-${i}`} className={inputCls} />
        <input type="number" min={1} value={m.priority} onChange={(e) => upd(i, "priority", e.target.value)} data-testid={`jarvis-team-priority-${i}`} className={inputCls} />
        <button onClick={() => setOpen(!open)} title="Permissions" data-testid={`jarvis-team-perms-toggle-${i}`} className="h-10 rounded-xl text-cyan-200 hover:bg-cyan-400/10 flex items-center justify-center">
          <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
        </button>
        <button onClick={() => remove(i)} data-testid={`jarvis-team-remove-${i}`} className="h-10 rounded-xl text-gray-500 hover:text-red-300 hover:bg-red-400/10 flex items-center justify-center"><Trash2 className="w-4 h-4" /></button>
      </div>
      {open && (
        <div className="space-y-3">
          <div className="flex flex-wrap gap-2">
            <button onClick={() => upd(i, "permissions", Object.fromEntries(Object.keys(perms).map((k) => [k, !allOn])))} className={`${HUD.ghost} h-8 px-3 text-xs`} data-testid={`jarvis-team-all-${i}`}>{allOn ? "Uncheck all" : "Full access"}</button>
            <label className="flex items-center gap-2 text-xs text-amber-200 rounded-full border border-amber-400/30 px-3 h-8">
              <input type="checkbox" checked={!!m.needs_approval} onChange={(e) => upd(i, "needs_approval", e.target.checked)} data-testid={`jarvis-team-needs-approval-${i}`} />
              Changes need approval
            </label>
          </div>
          <div className="grid sm:grid-cols-2 gap-x-4 gap-y-2">
            {Object.entries(perms).map(([k, label]) => (
              <label key={k} className="flex items-center gap-2 text-xs text-gray-300">
                <input type="checkbox" checked={p[k] !== false && (p[k] ?? !["approve_requests", "receive_approval_texts"].includes(k))} onChange={(e) => setPerm(k, e.target.checked)} data-testid={`jarvis-team-perm-${k}-${i}`} />
                {label}
              </label>
            ))}
          </div>
          <label className="block space-y-1">
            <span className={HUD.label}>How JARVIS talks to {m.name || "them"} (learned automatically — edit anytime)</span>
            <textarea rows={2} value={m.style || ""} onChange={(e) => upd(i, "style", e.target.value)} placeholder="e.g. Likes quick answers, casual, wants totals first" data-testid={`jarvis-team-style-${i}`} className={`w-full rounded-xl p-3 text-xs border ${HUD.input}`} />
          </label>
        </div>
      )}
    </div>
  );
};

export const TeamEditor = ({ team, setTeam }) => {
  const [perms, setPerms] = useState({});
  useEffect(() => { apiGet("/admin/jarvis/permissions").then((d) => setPerms(d.permissions)).catch(() => {}); }, []);
  const upd = (i, k, v) => setTeam(team.map((m, j) => (j === i ? { ...m, [k]: v } : m)));
  return (
    <div className="space-y-2">
      {team.map((m, i) => <Member key={i} m={m} i={i} perms={perms} upd={upd} remove={(x) => setTeam(team.filter((_, j) => j !== x))} />)}
      <button onClick={() => setTeam([...team, { name: "", phone: "", role: "", priority: team.length + 1, permissions: {} }])} data-testid="jarvis-team-add" className={`${HUD.ghost} h-9 px-4 text-sm flex items-center gap-1`}>
        <Plus className="w-4 h-4" /> Add person
      </button>
    </div>
  );
};

export default TeamEditor;
